export default function (seconds, format = 'h [h] m [m]') {
    return window.moment.duration(seconds, "seconds").format(format);
}